import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { getUrlPathname } from 'utils/common';
import { saveKeyword as saveKeywordApi } from 'api/case';
import './searchbox.less';

class Searchbox extends Component {
  static propTypes = {
    cover: PropTypes.array,
    keywordId: PropTypes.number,
    keyword: PropTypes.string,
    hotWords: PropTypes.array,
    setKeyword: PropTypes.func,
    closeSearchInput: PropTypes.bool,
  };

  constructor(props) {
    super(props);
    // 默认条数
    this.tempwindow = null;
    this.state = {
      // 是否有输入值
      hasValue: false,
    };
  }

  componentDidMount() {
    const { closeSearchInput } = this.props;
    const hideSearchInput = closeSearchInput === true;

    if (!hideSearchInput) {
      this.getPathName();
      const hasValue = !!this.input.value;
      this.setState({ hasValue });
    }
  }

  // 热门关键词列表
  hotwordList() {
    const { hotWords } = this.props;
    const htmls = [];
    for (const item of hotWords) {
      const { keywordId, keyword } = item;
      let link = `/preview/search-${keywordId}.html`;
      htmls.push(
        <li key={keywordId}>
          <a
            className="hotword"
            key={keywordId}
            data-id={keywordId}
            onClick={this.selectHotword.bind(this, keyword)}
            href={link}
            target="_blank"
            rel="noopener noreferrer">
            {keyword}
          </a>
        </li>
      );
    }
    return htmls;
  }

  // 设置搜索关键词
  // 选择热词作为关键词
  selectHotword = keyword => {
    this.props.setKeyword(keyword);
  };
  // 搜索
  onSearch = async () => {
    const { keyword } = this.props;
    const inputKeyword = this.input.value;
    if (!inputKeyword) return false;
    this.setState({ hasValue: true });
    if (keyword !== inputKeyword) {
      const tempwindow = window.open('', '_blank');
      const resData = await saveKeywordApi(inputKeyword);
      const keywordId = resData.data.keywordId;
      tempwindow.location = `/preview/search-${keywordId}.html`;
    }
  };

  getPathName = () => {
    const pathname = getUrlPathname();
    if (pathname == '/preview' || pathname == '/preview/') {
      this.clearInput();
    } else {
      this.input.value = this.props.keyword;
    }
  };

  // 检测输入
  onInput = () => {
    const hasValue = !!this.input.value;
    this.setState({ hasValue });
  };

  // 快捷键搜索
  onKeyDown = e => {
    // 回车键
    if (e.keyCode === 13) {
      this.onSearch();
    }
  };

  // 清空搜索
  clearInput = () => {
    this.input.value = '';
    this.setState({ hasValue: false });
  };

  render() {
    const { cover, closeSearchInput } = this.props;
    const hideSearchInput = closeSearchInput === true;
    const style =
      (cover && {
        backgroundImage: `url(${cover[0] ? cover[0].imageUrl : ''})`,
      }) ||
      null;

    return (
      <div>
        <div className="searchbox" style={style}>
          {!hideSearchInput && (
            <>
              <div className="input-box">
                <input
                  type="text"
                  placeholder="请输入要搜索的关键词"
                  defaultValue={this.props.keyword}
                  onKeyDown={this.onKeyDown}
                  onInput={this.onInput}
                  ref={node => (this.input = node)}
                />
                <span className="icon-box" title="搜索" onClick={this.onSearch}>
                  <i className="s-icon icon-search" />
                  <span>搜索</span>
                </span>
                <span
                  className={classnames('clear-btn', {
                    active: this.state.hasValue,
                  })}
                  title="清空"
                  onClick={this.clearInput}
                />
              </div>
              <div className="hotwords">
                <span className="hotwords-label">热门搜索：</span>
                <ul className="hotwords-list">{this.hotwordList()}</ul>
              </div>
            </>
          )}
        </div>
      </div>
    );
  }
}

export default Searchbox;
